import React from 'react'

import {
  Container,
  ProfileImage,
  WrapperHeader,
  DivInfo,
  DivName,
  Wrapper,
} from '../styles'

import PrimaryHeader from '../../../../components/primary-header'
import Title from '../../../../components/title'
import FormFactory from '../../../../components/form/form-factory'

import mail from '../../../../assets/svg/mail.svg'
import wpp from '../../../../assets/svg/whatsapp-line.svg'
import userIMG from '../../../../assets/png/user-profile.png'

import IFormPage from '../../../../interfaces/form-page'

import { ProfileEditProps } from '../props'

import LinkBuilder from '../../../../helpers/helper-link-builder'

type IProps = ProfileEditProps & IFormPage & any

const EditHeaderData = ({
  name,
  email,
  phone,
  imageUrl,
  dataForm,
  onSubmit,
  errorMessage,
}: IProps): JSX.Element => (
  <Container>
    <PrimaryHeader>
      <Title>
        <span>Voltar</span>
      </Title>
      <WrapperHeader>
        <DivInfo>
          <ProfileImage
            src={imageUrl ? LinkBuilder.buildAssetsUrl(imageUrl) : userIMG}
            alt="Adicionar imagem"
          />
          <div>
            <DivName>
              Olá, Dr.&nbsp;
              {name}
            </DivName>
            <DivInfo>
              <img src={mail} alt="email" />
              {email}
            </DivInfo>
            <DivInfo>
              <img src={wpp} alt="whatsapp" />
              {phone}
            </DivInfo>
          </div>
        </DivInfo>
      </WrapperHeader>
    </PrimaryHeader>
    <Wrapper>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
      />
    </Wrapper>
  </Container>
)
export default EditHeaderData
